import React from 'react';
import { Link, useParams } from 'react-router-dom';
import methodModel from '../../../methods/methods';
import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import Sidebar from '../sidebar';
import { useNavigate } from 'react-router';

import { FiMenu, FiX } from 'react-icons/fi';
function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const Html = ({
  isOpen,
  toggle,
  searchHandle,
  user,
  search,
  isOpen1,
  searchChange,
  clear,
  Logout,
}) => {
  const history = useNavigate();
  const { id, userId } = useParams();

  return (
    <nav
      component="header"
      className={`${isOpen ? 'min-sidebar w-[calc(100%-80px)]' : 'w-[calc(100%-250px)] '
        } sidebar_width shadow-btn py-1.5 bg-[#f1f1f1] border-b  fixed transition-[width] duration-300 ml-auto right-0 z-10 flex items-center !px-5
      `}
    >
      <button
        onClick={toggle}
        className="baar_toggle h-9 w-9 shrink-0 shadow-btn hover:shadow-none p-1 rounded-lg border border-gray-100 !text-primary"
      >
        {!isOpen ? (
          <FiMenu className="w-full h-full" />
        ) : (
          <FiX className="w-full h-full" />
        )}
      </button>

      {window.location.pathname == '/profile/change-password' ||
        window.location.pathname == '/profile' ||
        // window.location.pathname == `/sub-admin/view/${id}` ||
        (window.location.pathname == `/users/edit/${id}`) |
        (window.location.pathname == `/assessment/add`) ||
        window.location.pathname == `/assessment/view/${id}` ||
        window.location.pathname == `/assessment/edit/${id}` ||
        window.location.pathname == `/assessment/edit/${id}` ||
        window.location.pathname == `/template/view/${id}` ||
        window.location.pathname == `/template/add` ||
        window.location.pathname == `/userDetail/${id}` ||
        window.location.pathname == `/sub-admin/view/${id}` ||
        window.location.pathname == `/sub-admin/edit/${id}` ||
        window.location.pathname == `/blog/view/${id}` ||
        window.location.pathname == `/categoryDetail/${id}` ||
        window.location.pathname == `/categories/edit/${id}` ||
        window.location.pathname == `/course/view/${id}` ||
        window.location.pathname == `/course/edit/${id}` ||
        window.location.pathname == `/content/view/${id}` ||
        window.location.pathname == `/content/edit/${id}` ||
        window.location.pathname == `/features/${id}` ||
        window.location.pathname == `/features/edit/${id}` ||
        window.location.pathname == `/plan/view/${id}` ||
        window.location.pathname == `/plans/edit/${id}` ||
        window.location.pathname == `/certification/edit/${id}` ||
        window.location.pathname == `/question/view/${id}` ||
        window.location.pathname == `/template/edit/${id}` ||
        window.location.pathname == `/sub-admin/add` ||
        window.location.pathname == `/users/add` ||
        window.location.pathname == `/categories/add` ||
        window.location.pathname == `/blog/add` ||
        // window.location.pathname == `/courses` ||
        window.location.pathname == `features/add` ||
        window.location.pathname == `/plans/add` ||
        window.location.pathname == `/question/add` ||
        window.location.pathname == `/certification/add` ||
        window.location.pathname == `/template/add` ||
        window.location.pathname == `/features/add` ||
        window.location.pathname == `/course/add` ||
        window.location.pathname == `/dashboard` ||
        window.location.pathname == `/faq/view/${id}` ||
        window.location.pathname == `/faq/edit/${id}` ||
        window.location.pathname == `/faq/add` ||
        window.location.pathname == `/lessons/parents` ||
        window.location.pathname == `/insights/coaches` ||
        window.location.pathname == `/menu` ||
        window.location.pathname == `/setting` ||
        window.location.pathname == '/profile/edit' 
        ? null : (
        <form className="headerSearch ml-3" onSubmit={searchHandle}>
          <input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => searchChange(e.target.value)}
            className="Searchbar"
          ></input>
          <i
            className="fa fa-search"
            onClick={searchHandle}
            aria-hidden="true"
          ></i>
          {search ? (
            <i className="fa fa-times" onClick={clear} aria-hidden="true"></i>
          ) : (
            <></>
          )}
        </form>
      )}

      {/* <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button> */}

      <Menu as="div" className="relative  ml-auto">
        <div>
          <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md px-3 py-1 text-sm font-semibold text-gray-900 ">
            <div className="flex items-center">
              <div className="flex items-center">
                <img
                  alt="image"
                  src={methodModel.userImg(user.image)}
                  className="h-9 w-9 rounded-full object-cover"
                />
                <div className="ml-2 text-left">
                  {methodModel.capitalizeFirstLetter(user?.firstName + " " + user?.lastName)}
                  <p className="grayCls mb-0 text-capitalize">
                    {methodModel.capitalizeFirstLetter(user?.role)}
                  </p>
                </div>
              </div>
              <i
                className="fa fa-angle-down top-1 relative h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </div>
          </Menu.Button>
        </div>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="py-1">
              <Menu.Item>
                {({ active }) => (
                  <Link
                    to="/profile"
                    className={classNames(
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'block px-4 py-2 text-sm'
                    )}
                  >
                    <i className="fa fa-user mr-2" /> Profile
                  </Link>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <Link
                    to="/profile/change-password"
                    className={classNames(
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'block px-4 py-2 text-sm'
                    )}
                  >
                    <i className="fa fa-cog mr-2" aria-hidden="true"></i> Change
                    Password
                  </Link>
                )}
              </Menu.Item>

              <Menu.Item className="divide-y-1 divide-gray-800 pt-1  mt-2">
                <p className="border-t"></p>
              </Menu.Item>

              <Menu.Item className="">
                {({ active }) => (
                  <a
                    type="submit"
                    onClick={() => Logout()}
                    className={classNames(
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'block w-full px-4 py-2 text-left text-sm hover:text-[#A12238] !important'
                    )}
                  >
                    <i className="fas fa-sign-out-alt mr-2" /> Logout
                  </a>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>

      {isOpen1 ? (
        <div className="w-100 mobi-dropdown">
          <Sidebar />
        </div>
      ) : (
        <></>
      )}
    </nav>
  );
};

export default Html;
